import React from "react";

const Footer = () => {
    return (
        <footer>
            Roosevelt Blow {'\u00A9'} 2023
        </footer>
    )
}

export default Footer;